import { useAuthStore } from "@kaplan-labs/up-auth-api-client";
import { useCallback, useEffect, useRef, useState } from "react";

import { logError, serverRoutes } from "@up/data";

import type { TLineItem, TOrder } from "@up/data";
import type { ReactNode } from "react";

type WhatINeed = TLineItem & { order: TOrder };

const GALAXY_URI = process.env["NEXT_PUBLIC_HALL_OF_RECORDS_URI"] as string;
export const LoadOrders = function ({
  children,
  orderIds,
}: {
  children: (props: {
    error: string;
    getCourses: () => Promise<void>;
    isLoading: boolean;
    courses: Array<WhatINeed> | undefined;
  }) => ReactNode;
  orderIds: string[];
}) {
  const auth = useAuthStore();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [courses, setCourses] = useState<Array<WhatINeed> | undefined>(
    undefined,
  );

  const getCourses = useCallback(
    async function () {
      try {
        const orders = await Promise.all(
          orderIds.map((id) => {
            const URL = GALAXY_URI + serverRoutes.orders.getById(id);
            return auth.client
              .get(URL)
              .json<{ data: TOrder }>()
              .then((r) => r.data);
          }),
        );

        setCourses(
          orders
            .map((order) => {
              return order.lineItems.flat().map((item) => {
                return {
                  ...item,
                  order,
                };
              });
            })
            .flat(),
        );
      } catch (e) {
        logError({ action: "LOAD_ORDERS", error: e, context: { orderIds } });
        setError("error");
      }
      setIsLoading(false);
    },
    [auth.client, orderIds],
  );

  const fetchStarted = useRef(false);
  useEffect(() => {
    if (!fetchStarted.current) {
      fetchStarted.current = true;
      getCourses();
    }
  }, [getCourses]);

  return children({ error, getCourses, isLoading, courses });
};
